import { render, staticRenderFns } from "./PricingInfo.vue?vue&type=template&id=6ef99d4b&scoped=true"
import script from "./PricingInfo.vue?vue&type=script&lang=js"
export * from "./PricingInfo.vue?vue&type=script&lang=js"
import style0 from "./PricingInfo.vue?vue&type=style&index=0&id=6ef99d4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef99d4b",
  null
  
)

export default component.exports